import {
  lmnLetterLookupQuerySchema,
  lmnLetterLookupResultSchema,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/lmn-letter-lookup";

/**
 * Redo staff search for a shopper's orders across every HSA provider merchant,
 * with each letter's Beluga master id for amendments. Admin role only (never
 * recovery contractors); every call is audited and rate limited per admin.
 */
export const lookupHsaLmnLetters = {
  name: "lookupHsaLmnLetters" as const,
  input: lmnLetterLookupQuerySchema,
  output: lmnLetterLookupResultSchema,
};
